module.exports = __webpack_public_path__ + "media/images/icon__form--checkmark-aa1d949cc51828c7bfa905bfeaefa558.png";